import { axiosInstance } from "./AxiosDefaults";
import { partnersRoute } from "../constants/ApiRoutes";
import { Partner } from "../models/Partner";

export type ApiResponse<T> = {
  status?: "SUCCESS" | "ERROR";
  message?: string;
  result?: T;
};

export const getAllPartners = (): Promise<any> => {
  return axiosInstance.get(partnersRoute, {
    withCredentials: false,
    headers: { "Content-Type": "application/json" },
  });
};

export const getOnePartner = (id: string): Promise<any> => {
  return axiosInstance.get(`${partnersRoute}/${id}`, {
    withCredentials: false,
    headers: { "Content-Type": "application/json" },
  });
};

export const createPartner = (payload: Partial<Partner>): Promise<any> => {
  return axiosInstance.post(partnersRoute, payload, {
    withCredentials: false,
    headers: { "Content-Type": "application/json" },
  });
};

export const updateOnePartner = (id: string, payload: Partial<Partner>): Promise<any> => {
  return axiosInstance.put(`${partnersRoute}/${id}`, payload, {
    withCredentials: false,
    headers: { "Content-Type": "application/json" },
  });
};
